import FormattedMessage from 'I18n/components/FormattedMessage';
import { esignErrorCategory } from '../api/esignError';
import { jsx as _jsx } from "react/jsx-runtime";
export function isUserOutstandingSigner(userEmail, quoteSigners) {
  const userSigner = quoteSigners.find(signer => signer.email === userEmail);
  return userSigner && userSigner.signedAt === null;
}
export function buildSigningPageUrl() {}
export function getOpenSigningPageErrorAlert(error) {
  const titleText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "quotesUiLib.countersignButton.openSigningPageError.title"
  });
  if (error.responseJSON && error.responseJSON) {
    const esignError = error.responseJSON;
    if (esignError.subCategory === esignErrorCategory.RATE_LIMITED_FOR_SIGNATURE_DETAILS_GENERATION) {
      return {
        type: 'warning',
        titleText,
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "quotesUiLib.countersignButton.openSigningPageError.rateLimitMessage"
        })
      };
    } else if (esignError.subCategory === esignErrorCategory.QUOTE_NOT_READY_FOR_SIGNING) {
      return {
        type: 'warning',
        titleText,
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "quotesUiLib.countersignButton.openSigningPageError.notReadyForSigningMessage"
        })
      };
    } else if (esignError.subCategory === esignErrorCategory.SIGNER_ALREADY_SIGNED) {
      return {
        type: 'danger',
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "quotesUiLib.countersignButton.openSigningPageError.signerAlreadySignedMessage"
        })
      };
    }
  }
  return {
    type: 'danger',
    titleText,
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.countersignButton.openSigningPageError.unknownMessage"
    })
  };
}